import { createQueryClientCaches } from '@/api/queryClientDefaults';
import { useToastContext } from '@payaca/ambrosia';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useRef, useState } from 'react';

export const QueryClientWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pushError } = useToastContext();
  const pushErrorRef = useRef(pushError);

  useEffect(() => {
    pushErrorRef.current = pushError;
  }, [pushError]);

  const [queryClient] = useState(
    () => new QueryClient(createQueryClientCaches(pushErrorRef))
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </QueryClientProvider>
  );
};
